import React from 'react';

import { FormikValues } from 'formik';

import { GridElem } from '../../common/grid';
import { FieldTextElem } from '../../common/field-text';
import { ButtonElem } from '../../common/button';
import { LoaderElem } from '../../common/loader';
import { AlertActionElem } from '../../common/alert-action';
import { FormElem } from '../../common/form';
import styled from 'styled-components';
import { i18n } from '../../lib/lang';
import { TextElem } from '../../common/text';
import { DoubleContainerElem } from '../../common/double-container';
import closeIcon from '../../asset/svg/common/close.svg';
import { FORM_VALUE_ENUM } from '../project-item-create/constant';

import { FieldNumberElem } from '../../common/field-number';
import { convertUserListToSelect } from '../../data/user/convert';
import { getAllUserList } from '../../data/user/action';
import { SelectPreloadContainer } from '../select-preload';

export const Component: React.FC<{
  formik: FormikValues;
  isFieldError: Function;
  getFieldError: Function;
  isSubmitDisabled: Function;
  getFieldValue: Function;
  isLoading?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  errorMessage?: string;
  close: Function;
  setFieldValue: Function;
}> = ({
  formik,
  isFieldError,
  getFieldError,
  isSubmitDisabled,
  getFieldValue,
  isLoading,
  isSuccess,
  isError,
  errorMessage,
  close,
  setFieldValue,
}) => {
  return (
    <FormElem onSubmit={formik.handleSubmit}>
      {isLoading && <LoaderElem />}

      <GridElem spacing={5}>
        <TitleContainer>
          <TextElem tid="PROJECT.UPDATE.TITLE" type="semi-bold" size="main" />
          <Icon src={closeIcon} onClick={() => close()} />
        </TitleContainer>
        <DoubleContainerElem>
          <FieldTextElem
            name={FORM_VALUE_ENUM.NAME}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            title="PROJECT.FORM.NAME"
            value={getFieldValue(FORM_VALUE_ENUM.NAME)}
            errorMessage={getFieldError(FORM_VALUE_ENUM.NAME)}
            error={isFieldError(FORM_VALUE_ENUM.NAME)}
          />

          <FieldNumberElem
            name={FORM_VALUE_ENUM.BUDGET}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            title="PROJECT.FORM.BUDGET"
            value={getFieldValue(FORM_VALUE_ENUM.BUDGET)}
            errorMessage={getFieldError(FORM_VALUE_ENUM.BUDGET)}
            error={isFieldError(FORM_VALUE_ENUM.BUDGET)}
          />
        </DoubleContainerElem>

        <DoubleContainerElem>
          <FieldNumberElem
            name={FORM_VALUE_ENUM.REST_BUDGET}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            title="PROJECT.FORM.REST_BUDGET"
            value={getFieldValue(FORM_VALUE_ENUM.REST_BUDGET)}
            errorMessage={getFieldError(FORM_VALUE_ENUM.REST_BUDGET)}
            error={isFieldError(FORM_VALUE_ENUM.REST_BUDGET)}
          />
          <FieldNumberElem
            name={FORM_VALUE_ENUM.UNIQUE_NUMBER}
            title="PROJECT.FORM.UNIQUE_NUMBER"
            value={formik.values[FORM_VALUE_ENUM.UNIQUE_NUMBER]}
            onChange={formik.handleChange}
            disableDecimal
            errorMessage={getFieldError(FORM_VALUE_ENUM.REST_BUDGET)}
            error={isFieldError(FORM_VALUE_ENUM.REST_BUDGET)}
          />
        </DoubleContainerElem>

        <DoubleContainerElem style={{ alignItems: 'end' }}>
          <SelectPreloadContainer
            name={FORM_VALUE_ENUM.RESPONSIBLE}
            action={getAllUserList}
            convert={convertUserListToSelect}
            formik={formik}
            title="EXPENDITURE.FORM.RESPONSIBLE.TITLE"
            onChange={setFieldValue}
            errorMessage={getFieldError(FORM_VALUE_ENUM.RESPONSIBLE)}
            error={isFieldError(FORM_VALUE_ENUM.RESPONSIBLE)}
            value={getFieldValue(FORM_VALUE_ENUM.RESPONSIBLE)}
            dynamic
            placeholder="EXPENDITURE.FORM.RESPONSIBLE.PLACEHOLDER"
          />
          <ButtonStyled
            type="submit"
            tid="PROJECT.UPDATE.BUTTON"
            fill="solid"
            disabled={isSubmitDisabled()}
            color="success"
          />
        </DoubleContainerElem>

        {isError && <AlertActionElem text={i18n.t(`${errorMessage}`)} />}
        {isSuccess && <AlertActionElem type="success" tid="Success" />}
      </GridElem>
    </FormElem>
  );
};

const ButtonStyled = styled(ButtonElem)``;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Icon = styled.img`
  cursor: pointer;
`;
